<template>
  <div class="header-container">
    <div class="header-logo-container">
      <img src="@/assets/images/radiometer-logo2.png" alt="">
      <span>丹纳赫诊断平台</span>
    </div>
    <el-dropdown trigger="click">
      <div class="header-userinfo-container">
        <img :src="userInfo.avatar ? userInfo.avatar : avatarImage" alt="">
        <span>{{ userInfo.nickName }}</span>
        <i class="el-icon-caret-bottom" />
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="$router.push('/personal-settings/index')">
          个人设置
        </el-dropdown-item>
        <el-dropdown-item @click.native="loginOut">
          退出登录
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import store from '@/store'
import avatarImage from '@/assets/images/avatar.png'
import { getLoginInfo, logout } from '@/api/index'

export default {
  name: 'Header',
  data() {
    return {
      avatarImage,
      userInfo: {}
    }
  },
  mounted() {
    this.getLoginInfoData()
  },
  methods: {
    getLoginInfoData() {
      getLoginInfo().then((res) => {
        this.userInfo = res.data
      })
    },
    loginOut() {
      this.$confirm(`请确认是否退出登录?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        logout().then((response) => {
          if (response.code === 0) {
            store.commit('setToken', { token: '', tokenExpires: '' })
            this.$router.push('/login')
          }
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/styles/mixin";
@import "src/styles/env";

.header-container {
  @include baseFlex(flex, space-between, center);
  height: $headerHeight;
  color: #333;

  .header-logo-container {
    @include baseFlex(flex, flex-start, center);

    > img {
      margin-right: 32px;
      width: 66px;
      height: 30px;
    }
  }

  .header-userinfo-container {
    @include baseFlex(flex, flex-end, center);
    height: 60px;
    padding: 0 20px;

    &:hover {
      background-color: #f5f5f5;
      transition: 0.3s;
      cursor: pointer;
    }

    > img {
      height: 40px;
      width: 40px;
      border-radius: 50%;
      margin-right: 20px;
    }

    > span {
      margin-right: 20px;
    }
  }
}
</style>
